import React, { useEffect, useState } from 'react'
import SaveExtra from '../../services/general/saveExtraData.api'

const Addendum = ({ patientID, noteID }) => {
  const [addendum, setAddendum] = useState([])
  const userData = JSON.parse(localStorage.getItem('user')) || {}
  const role = userData?.Role || ''

  const fetchAddendumData = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'Addendum', '', '')

      data = JSON.parse(data?.d)?.Data || []
      data = data.map((item) => JSON.parse(item?.JsonData))

      data = data.reverse() // latest first

      const currentNoteID = noteID.toString()
      const noteIDNum = parseInt(noteID, 10)
      const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null

      const findPatientNoteData = (data, patientID, noteID) => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]

          if (item[patientID]) {
            if (item[patientID][currentNoteID]) {
              return item[patientID][currentNoteID]
            }

            if (previousNoteID && item[patientID][previousNoteID]) {
              return item[patientID][previousNoteID]
            }
          }
        }
        return null
      }

      const result = findPatientNoteData(data, patientID, noteID)
      if (result) {
        setAddendum(result)
      } else {
        const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID
        console.warn(`Patient ${patientID} with note ${searchNotes} not found`)
        setAddendum(null)
      }
    } catch (error) {
      console.error('Failed to fetch addendum data:', error)
      setAddendum(null)
    }
  }

  useEffect(() => {
    fetchAddendumData()
  }, [])

  const formatDate = (dateString) => {
    const parts = dateString?.split('-')
    if (!parts || parts.length !== 3) return ''
    const [month, day, year] = parts
    const date = new Date(`${year}-${month}-${day}`)
    return new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date)
  }

  const formatMedication = (medItem) => {
    const details = [medItem?.name, medItem?.dosage, medItem?.route, medItem?.frequency].filter(Boolean).join(' ')
    return medItem?.reason ? `${details} - ${medItem.reason}` : details
  }

  return (
    <>
      <div className=" ">
        <h5 className={role === 'provider' ? 'text-white' : ''}>Addendum</h5>

        <div className="rounded" style={{ border: '1px solid var(--ui-dashboard-border-strong, #3a3a3a)', padding: '13px', background: 'var(--ui-dashboard-surface-2, transparent)', color: 'var(--ui-text-primary, inherit)' }}>
          <div>
            {addendum && addendum.orders && addendum.orders.length > 0 ? (
              <div className="w-100">
                <div>
                  <strong>Date:</strong> {formatDate(addendum?.syncDate)}
                </div>
                <div className="mt-3 fw-bold">Orders</div>
                {addendum.orders.map((currentOrder, idx) => (
                  <div key={idx} className={idx === addendum.orders.length - 1 ? '' : 'mb-3 pb-3 border-bottom'}>
                    {currentOrder?.diagnosis && (
                      <div>
                        <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                      </div>
                    )}
                    {currentOrder?.medication?.medication?.length > 0 && (
                      <div>
                        <strong>Medications:</strong> {currentOrder.medication.medication.map(formatMedication).join(', ')}
                      </div>
                    )}
                    {currentOrder?.lab?.labs?.length > 0 && (
                      <div>
                        <strong>Labs:</strong>{' '}
                        {currentOrder.lab.labs
                          .map((labItem) => `${labItem?.lab || ''}${labItem?.reason ? ` - Reason for ${labItem.lab}: ${labItem.reason}` : ''}`)
                          .join(', ')}
                      </div>
                    )}
                    {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                      <div>
                        <strong>Imaging:</strong> {currentOrder.imaging.imagingTypes.map((imagingItem) => imagingItem?.type).join(', ')}
                      </div>
                    )}
                    {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                      <div>
                        <strong>Miscellaneous:</strong> {currentOrder.miscellaneous.miscellaneous.join(', ')}
                      </div>
                    )}
                  </div>
                ))}
                {addendum?.poac?.length > 0 && (
                  <>
                    <div className="mt-4 fw-bold">POAC</div>
                    <div style={{ whiteSpace: 'pre-wrap' }}>
                      {addendum.poac
                        .map((item) => item?.poacData?.content)
                        .filter(Boolean)
                        .join('\n\n')}
                    </div>
                  </>
                )}
              </div>
            ) : (
              <div className="text-center text-muted py-3">No addendum available.</div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}

export default Addendum
